import axios from "axios";
import {
    getSystemLang
} from "../lang";


export default function($url,$param){

    let domain  = window.location.protocol+"//"+window.location.host;
    // console.log(domain);
    axios.defaults.baseURL = '/swd/index.php/';
    // axios.defaults.baseURL = 'http://api.wifigolf.com/api/'; //正式
    if(window.location.hostname=="localhost"){
       
        // let max = 1;
        // let min = 0;
        // let number = Math.floor(Math.random() * (max - min + 1)) + min;
        // console.log(number,'number');
        // if(number%2==1)
        // {
        //     axios.defaults.baseURL = 'https://overview.wifigolf.com/api_wifigolf_com/public/index.php/';
        // }
        // else
        // {
        //     axios.defaults.baseURL = 'https://viewportal.wifigolf.com/api_wifigolf_com/public/index.php/';
            
        // }
        axios.defaults.baseURL = '/swd/';
    }else if(window.location.hostname=="pctest.wifigolf.com"){
        axios.defaults.baseURL = 'http://testapi.wifigolf.com/api/';
    }else{
        // axios.defaults.baseURL = 'https://api.wifigolf.com/api/'; //正式

        let max = 1;
        let min = 0;
        let number = Math.floor(Math.random() * (max - min + 1)) + min;
        if(number%2==1)
        {
            axios.defaults.baseURL = 'https://overview.wifigolf.com/api_wifigolf_com/public/index.php/';
        }
        else
        {
            axios.defaults.baseURL = 'https://viewportal.wifigolf.com/api_wifigolf_com/public/index.php/';
        }
        
    }
    let tparam = [];
    if($param instanceof Object)
    {
        for(let key in $param)
        {
            tparam.push(key+'='+ encodeURIComponent($param[key]));
        }
    }
    $url = $url+'?'+tparam.join("&"); 
    return axios.get($url);
}